import {useSelector} from "react-redux";
import {RootState} from "../../../store";
import "./LoginNavigation.css";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {makeLink} from "../../common/languages-helper";


interface LoginNavigationProps {
    isAuthenticated:boolean,
    loginFunction:any,
    logout:any
}
const LoginNavigation: React.FC<LoginNavigationProps> = ({loginFunction, logout, isAuthenticated}) => {
    const profileData = useSelector((state: RootState) => state.profile);
    const {t} = useTranslation();
    if(!profileData) {
        return <div></div>
    }
    return <div className={"login-widget"}>
        {isAuthenticated ?
            <>
                {/* Mobile auth lives in the hamburger drawer (MobileMenu). */}
                <div className={"desktop"}>
                    <Link to={makeLink("/profile")}>{t("Profile")}</Link> / <a href="#" onClick={() => logout()}>{t("Logout")}</a>
                </div>
            </>
            :
            <>
                {/* Mobile auth lives in the hamburger drawer (MobileMenu). */}
                <div className={"desktop"}>
                     <a className={"login-signin-btn"} href={"#"} onClick={(event:any)=>{loginFunction(null,event)}}>{t("Sign In")}</a>
                     <span className={"login-divider"}>/</span>
                     <a className={"login-signup-link"} href={"#"} onClick={(event:any) => loginFunction({authorizationParams: { screen_hint: "signup" }},event)}>{t("Sign Up")}</a>
                </div>
            </>
        }
    </div>
}
export default LoginNavigation;
